import { Routes } from "@angular/router";
import { authGuard } from "./guards/auth.guard";
import { layoutResolver } from "./layout.resolver";

export const APP_ROUTES: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./components/auth/auth.routes').then((x) => x.AuthRoutes),
  },
  {
    path: 'auth-code',
    loadComponent: () => import('./components/auth-code/auth-code').then(m => m.AuthCodeComponent),
  },
  // Dev/test routes — no auth required (uncomment to access /dev/buttons)
  {
    path: 'dev/buttons',
    loadComponent: () => import('./components/shared/button-showcase/button-showcase').then(m => m.ButtonShowcaseComponent),
  },
  {
    path: '',
    loadComponent: () => import('./layouts/layout').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    resolve: { layout: layoutResolver },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.routes').then(m => m.DashboardRoutes),
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'auth/login'
  }
];
